import { injectable } from 'inversify';

import { HttpService } from '@vk-hr-tek/core/http';
import { UnmarshallerService } from '@vk-hr-tek/core/unmarshaller';

import { CreateEventBatchDocumentZipResponse } from '@app/gen/events';

import { BatchDownloadStartDto } from '../dto';

@injectable()
export class EventsDownloadService {
  constructor(
    private http: HttpService,
    private unmarshaller: UnmarshallerService,
  ) {}

  async startDownload(batchDownloadStartDto: BatchDownloadStartDto) {
    return this.unmarshaller.unmarshall(
      await this.http.post(
        '/event/batch/document/zip',
        { event_ids: batchDownloadStartDto.event_ids },
        { withSide: true },
      ),
      CreateEventBatchDocumentZipResponse,
    );
  }
}
